import { EMPTY_LIST } from '../../../../constants/common'

export const QA_NAME_EDIT_BUILDINGS_MODAL = 'editBuildings'

export const BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING = 'buildings'

export const BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS =
  'perform_for_buildings'

export const EDIT_BUILDING_FORM_INITIAL_VALUES = {
  [BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_BUILDING]: EMPTY_LIST,
  [BUILDING_GROUP_EDIT_BUILDINGS_FIELD_NAME_UPDATE_MANAGERS]: false,
}

export const BUILDING_GROUP_EDIT_BUILDINGS_FORM_TEST_NAME_EMPTY_LIST =
  'empty_buildings'
